// Shared markdown component overrides for Field Notes — used by the public
// BlogPost page and by the Admin "Preview" tab in the Field Note editor so
// what the writer sees is what the reader sees.
export const MD_COMPONENTS = {
  h1: ({ children }) => <h2 className="font-display text-4xl md:text-5xl text-brand-ink mt-12 mb-4 leading-tight">{children}</h2>,
  h2: ({ children }) => <h2 className="font-display text-3xl md:text-4xl text-brand-ink mt-10 mb-4 leading-tight">{children}</h2>,
  h3: ({ children }) => <h3 className="font-serif text-2xl text-brand-ink mt-8 mb-3">{children}</h3>,
  p: ({ children }) => <p className="text-brand-ink leading-relaxed text-lg mt-5">{children}</p>,
  ul: ({ children }) => <ul className="list-disc pl-6 mt-5 space-y-2 text-brand-ink text-lg leading-relaxed">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-6 mt-5 space-y-2 text-brand-ink text-lg leading-relaxed">{children}</ol>,
  li: ({ children }) => <li className="leading-relaxed">{children}</li>,
  blockquote: ({ children }) => (
    <blockquote className="mt-6 border-l-4 border-brand-rust pl-5 py-1 italic text-brand-ink text-lg leading-relaxed">{children}</blockquote>
  ),
  a: ({ href, children }) => (
    <a href={href} className="text-brand-rust underline underline-offset-4 hover:text-brand-ink" target={href?.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">{children}</a>
  ),
  strong: ({ children }) => <strong className="text-brand-ink font-semibold">{children}</strong>,
  em: ({ children }) => <em className="text-brand-ink italic">{children}</em>,
  hr: () => <hr className="my-10 border-brand-line" />,
  code: ({ children }) => <code className="bg-brand-bg px-1.5 py-0.5 text-sm font-mono text-brand-ink">{children}</code>,
};
